import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { IResponseSuccess } from '../../core/interfaces/response.interface';
import {
  IUnifiedActivateRequest,
  IUnifiedBackgroundCheckDateItem,
  IUnifiedBackgroundCheckDetail,
  IUnifiedDeactivateRequest,
  IUnifiedDownloadResult,
  IUnifiedRunCheckResult,
  UnifiedBackgroundCheckSource
} from '../../core/interfaces/unified-background-check.interface';

@Injectable()
export class DriverBackgroundCheckApiService extends ParentService {

  constructor(private _http: Http) {
    super();
  }

  getReportDates(driverId: number): Observable<IUnifiedBackgroundCheckDateItem[]> {
    return this._http
      .get(`${constant.URL_UNIFIED_BACKGROUND_CHECK_DATES}${driverId}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  getReportDetail(source: UnifiedBackgroundCheckSource, nativeId: string): Observable<IUnifiedBackgroundCheckDetail> {
    return this._http
      .get(`${constant.URL_UNIFIED_BACKGROUND_CHECK_REPORT_DETAIL}${source}/${nativeId}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  runCheck(driverId: number): Observable<IUnifiedRunCheckResult> {
    return this._http
      .post(`${constant.URL_UNIFIED_BACKGROUND_CHECK_RUN_CHECK}${driverId}`, null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  deactivate(source: UnifiedBackgroundCheckSource, driverId: number, body: IUnifiedDeactivateRequest): Observable<IResponseSuccess> {
    return this._http
      .put(`${constant.URL_UNIFIED_BACKGROUND_CHECK_DEACTIVATE}${source}/${driverId}`, JSON.stringify(body), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  activate(source: UnifiedBackgroundCheckSource, driverId: number, body: IUnifiedActivateRequest): Observable<IResponseSuccess> {
    return this._http
      .put(`${constant.URL_UNIFIED_BACKGROUND_CHECK_ACTIVATE}${source}/${driverId}`, JSON.stringify(body), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  download(source: UnifiedBackgroundCheckSource, nativeId: string): Observable<IUnifiedDownloadResult> {
    return this._http
      .get(`${constant.URL_UNIFIED_BACKGROUND_CHECK_DOWNLOAD}${source}/${nativeId}`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/driver-background-check-api.service.ts